import { SensorType, isSensorHidden } from "@ui/utils/sensors";
import { AP_NODE_TYPE_CODE, RELAYED_SENSOR_TYPE_CODE, } from "../nodes/edit-node/nodeTypeThreeForm";
/** The sensors a report can be run on, in tab order. */
export const REPORT_SENSORS = [
    {
        sensor: SensorType.InternalTemperature,
        labelKey: "common:labels.internalTemperature",
        name: "Temperature",
        shortName: "Temp",
        unit: "°C",
        decimals: 1,
        nodeTypeCodes: "all",
    },
    {
        sensor: SensorType.ExternalTemperature,
        labelKey: "common:labels.externalTemperature",
        name: "External Temperature",
        shortName: "Ext. Temp",
        unit: "°C",
        decimals: 1,
        nodeTypeCodes: [RELAYED_SENSOR_TYPE_CODE],
    },
    {
        sensor: SensorType.Co2,
        labelKey: "common:labels.co2",
        name: "CO₂",
        shortName: "CO₂",
        unit: " ppm",
        decimals: 0,
        nodeTypeCodes: [AP_NODE_TYPE_CODE],
    },
    {
        sensor: SensorType.Humidity,
        labelKey: "common:labels.humidity",
        name: "Humidity",
        shortName: "Humidity",
        unit: "%",
        decimals: 1,
        nodeTypeCodes: [RELAYED_SENSOR_TYPE_CODE, AP_NODE_TYPE_CODE],
    },
];
export const DEFAULT_REPORT_SENSOR = REPORT_SENSORS[0];
/** Whether a node of this type has the sensor (an option without a type is taken as an older node type). */
export const sensorSupportedBy = (meta, nodeTypeCode) => meta.nodeTypeCodes === "all" ||
    (nodeTypeCode !== undefined && meta.nodeTypeCodes.includes(nodeTypeCode));
/**
 * The sensor tabs a node selection supports: the internal temperature plus every sensor any selected node has. Older node
 * types only have the internal temperature, so a selection of those has a single entry (no tabs).
 */
export const applicableReportSensors = (nodes) => REPORT_SENSORS.filter((meta) => meta.nodeTypeCodes === "all" ||
    nodes.some((node) => sensorSupportedBy(meta, node.nodeTypeCode) &&
        !isSensorHidden(node.disabledSensors, meta.sensor)));
export const reportSensorMeta = (sensor) => { var _a; return (_a = REPORT_SENSORS.find((s) => s.sensor === sensor)) !== null && _a !== void 0 ? _a : DEFAULT_REPORT_SENSOR; };
/** A value with the sensor's decimals, or "-" when there is none. */
export const formatReportValue = (value, meta, withUnit = false) => {
    if (value === null || value === undefined)
        return "-";
    return value.toFixed(meta.decimals) + (withUnit ? meta.unit : "");
};
